module.exports = __webpack_public_path__ + "static/media/TSC-plain.41dbd696.png";